<template>
  <div class="ws-button-with-popup">
    <WsButton001
      v-click-outside="closePopup"
      :disable="disable"
      :width-stretch="widthStretch"
      :leading-icon="leadingIcon"
      @click="$_popActive()"
    >
      {{ textLabel }}
    </WsButton001>
    <div
      class="ws-button-with-popup__popup"
      :class="{active:popupActive,'position-up':isPositionUp}"
    >
      <div
        v-for="(item,itemIndex) in btnList"
        :key="itemIndex"
        class="ws-button-with-popup__popup-item"
        :class="{disabled:item.disabled}"
        @click.stop="$_click(item)"
      >
        <p :class="{disabled:item.disabled}">
          {{ item.text }} {{ item.hint }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "WsButtonWithPopup001",

  directives: {
    ClickOutside,
  },

  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    isPositionUp: {
      type: Boolean,
      default: false,
    },
    widthStretch: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: "",
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data: () => ({
    popupActive: false,
  }),

  methods: {
    $_popActive() {
      this.popupActive = !this.popupActive;
    },
    $_click(item) {
      if (item.disabled) return;
      this.$emit("btn-click", item);
      this.closePopup();
    },
    closePopup() {
      this.popupActive = false;
    },
  },
};
</script>